import React from 'react';

const Page500 = () => {
  return <div>500 Error Occurred</div>;
};

export default Page500;
